import { useEffect } from 'react'
import { COGNITO_DOMAIN, REDIRECT_URI, CLIENT_ID } from './ConfigLoader'
import { handleSuccessfulLogin, linkAccounts } from 'utils/aws/authService'
import { apiClient } from 'utils/api/apiClient'
import { useNavigate } from 'react-router-dom'

const OauthCallbackPage = () => {
  const navigate = useNavigate()
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const authorizationCode = urlParams.get('code')
    const redirectUri =
      window.location.origin +
      '/callback' +
      window.location.search.split('&')[0]
    // console.log(authorizationCode)
    // console.log('redirectUri to use:', redirectUri)

    //Grab the URI HERE
    if (authorizationCode) {
      // Exchange the authorization code for tokens
      exchangeAuthorizationCodeForTokens(authorizationCode, redirectUri)
    } else {
      console.error('Authorization code not found in the URL.')
    }
  }, [])

  const handleNewAuthRequest = async () => {
    const response = await apiClient.get('api/assets')
    // console.log(response)
  }

  async function exchangeAuthorizationCodeForTokens(code, redirectUri) {
    const tokenUrl = `https://${COGNITO_DOMAIN}/oauth2/token`
    // console.log('is this working?')
    // console.log(redirectUri)
    // console.log(CLIENT_ID)
    const params = new URLSearchParams()
    params.append('grant_type', 'authorization_code')
    params.append('client_id', CLIENT_ID)
    params.append('redirect_uri', redirectUri)
    params.append('code', code)

    try {
      const response = await fetch(tokenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      })

      const data = await response.json()

      if (response.ok) {
        await handleSuccessfulLogin({
          ExpiresIn: data.expires_in,
          IdToken: data.id_token,
          AccessToken: data.access_token,
          RefreshToken: data.refresh_token,
        })
        const cleanedRedirection = window.location.search.replace(
          '?redirect_to=' + window.location.origin,
          ''
        )
        navigate(cleanedRedirection.split('&')[0])
      } else {
        console.error('Error exchanging code for tokens:', data)
      }
    } catch (error) {
      console.error('Error during token exchange:', error)
    }
  }

  return (
    <>
      {/* <div>Authenticating...</div> */}
      {/* <div>
        <button onClick={handleNewAuthRequest}>Click me </button>
      </div> */}
    </>
  )
}

export default OauthCallbackPage
